import { render, staticRenderFns } from "./NavbarSection.vue?vue&type=template&id=5c75ad52&"
import script from "./NavbarSection.vue?vue&type=script&lang=js&"
export * from "./NavbarSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports